<app-modal-v2 #modal customClassName="element-visibility-modal">
  @if (element) {
    <div class="modal-content">
      <div class="modal-body">
        <h2 class="modal-title">Visibility Settings</h2>

        <div class="visibility-settings">
          <div class="setting-row">
            <label>Default Visibility</label>
            <app-input-select
              [items]="visibilityOptions"
              [parentForm]="settingsForm"
              controlName="defaultVisible"
            ></app-input-select>
          </div>

          @if (!defaultVisible && conditionRows.length > 1) {
            <div class="setting-row">
              <label>Operator</label>
              <app-input-select
                [items]="operatorOptions"
                [parentForm]="settingsForm"
                controlName="visibilityOperator"
              ></app-input-select>
            </div>
          }
        </div>

        @if (!defaultVisible) {
          <div class="conditions-section">
            <div class="conditions-header">
              <label>Visible when...</label>
              <app-button
                text="+ Add Condition"
                type="button"
                variant="info"
                size="sm"
                (clicked)="addCondition()"
              />
            </div>

            @if (conditionRows.length === 0) {
              <div class="no-conditions">No conditions configured. Element will always be hidden.</div>
            }

            @for (row of conditionRows; track $index) {
              <div class="condition-row">
                <div class="condition-field question-field">
                  <app-input-select
                    [items]="sourceElementOptions"
                    [parentForm]="row.form"
                    controlName="sourceElementId"
                    inputPlaceholder="Select question..."
                    (valueChanged)="onSourceElementChanged(row, $event)"
                  ></app-input-select>
                </div>

                <span class="condition-equals">=</span>

                <div class="condition-field answer-field">
                  <app-input-select
                    [items]="row.sourceElementOptions"
                    [parentForm]="row.form"
                    controlName="sourceOptionId"
                    inputPlaceholder="Select answer..."
                  ></app-input-select>
                </div>

                <a class="condition-remove" (click)="removeCondition($index)"><i class="far fa-times"></i></a>
              </div>
            }

            @if (conditionRows.length === 0) {
              <pgo-callout size="sm" variant="warning">
                <span>Hidden elements must have at least one condition to become visible.</span>
              </pgo-callout>
            }
          </div>
        }
      </div>

      <div class="modal-footer">
        <div class="modal-footer-buttons">
          <app-button text="Cancel" variant="secondary" width="fill"
                      type="button" (click)="hide()"/>

          <app-button text="Apply" (clicked)="onHandleApply()" [disabled]="isApplyDisabled" variant="primary"
                      width="fill"
                      type="button"/>
        </div>
      </div>
    </div>
  }
</app-modal-v2>
